import { useCallback, useEffect, useState } from 'react';

import adminAPI from '@/api/admin';
import Search from '@/components/Search';
import IOrganisation from '@/types/IOrganisation';

interface OrgSearchDropdownProps {
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  onSelect: (orgID: number, displayText: string) => void;
  placeholder?: string;
}

export default function OrgSearchDropdown({
  search,
  setSearch,
  onSelect,
  placeholder = 'Search for organisations',
}: OrgSearchDropdownProps) {
  const [showOptions, setShowOptions] = useState(false);
  const [orgData, setOrgData] = useState<IOrganisation[]>();
  const [hasSearched, setHasSearched] = useState(false);

  const listOrganisations = useCallback(async (newOrgSearch: string) => {
    const res = await adminAPI.listOrganisations({
      pageSize: 5,
      search: newOrgSearch,
    });

    setOrgData(res.data?.data?.filter((item: IOrganisation) => item.name));
    setHasSearched(true);

    return res.data;
  }, []);

  // Clear orgData when user clears search after having searched
  useEffect(() => {
    if (search.length === 0 && hasSearched) {
      setOrgData(undefined);
      setHasSearched(false);
    }
  }, [search, hasSearched]);

  return (
    <div className="relative">
      <Search
        id={`OrganisationList-1-20-date-desc--${search}`}
        placeholder={placeholder}
        search={search}
        setSearch={value => {
          if (value !== search) {
            onSelect(-1, '');
            setShowOptions(true);
          }
          setSearch(value);
        }}
        fetchQuery={newOrgSearch => listOrganisations(newOrgSearch)}
        fetchEnabled={search.length > 0}
      />
      {search && showOptions && (
        <div className="origin-top-left absolute right-0 mt-2 w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
          <div className="py-1">
            {orgData && orgData?.length ? (
              orgData?.map((item: IOrganisation) => (
                <button
                  type="button"
                  key={item.id}
                  className="appearance-none px-3 py-2 cursor-pointer hover:bg-gray-200 w-full text-left"
                  onClick={() => {
                    onSelect(item.id, `#${item.id} ${item.name}`);
                    setShowOptions(false);
                    setSearch(`#${item.id} ${item.name}`);
                  }}
                >
                  #{item.id} <span className="text-gray-500">{item.name}</span>
                </button>
              ))
            ) : (
              <li className="px-3 py-2 text-center">No matching items found</li>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
